import { render } from "./PackageUpgrade.vue?vue&type=template&id=6331754f&scoped=true"
import script from "./PackageUpgrade.vue?vue&type=script&lang=js"
export * from "./PackageUpgrade.vue?vue&type=script&lang=js"

import "./PackageUpgrade.vue?vue&type=style&index=0&id=6331754f&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6331754f"]])

export default __exports__